export default __webpack_public_path__ + "static/media/superlogo.be106a38.png";